console.log("components");
import "./jquery.js";

import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Mousewheel } from "swiper/modules";
const App = {
  init() {
    // this.burger();
    this.modalWindow();
    this.accordion();
    this.tabsModule();
    this.sliderSolutions();
    this.sliderCertificates();
    this.sliderCommand();
    this.geographyTabs();
    this.playVideo();
    this.scrollTo($(".link-to-form"));
    this.yandexMap();
    this.headerChangeBackground();
    this.PortfolioTabsFilter();
  },

  burger() {
    const burger = document?.querySelector("[data-burger]");
    const menu = document?.querySelector("[data-menu]");
    const menuItems = document?.querySelectorAll("[data-menu-item]");
    const overlay = document?.querySelector("[data-menu-overlay]");
    const burgerClose = document?.querySelector("[data-burger-close]");

    burger?.addEventListener("click", (e) => {
      burger?.classList.toggle("burger--active");
      menu?.classList.toggle("menu--active");

      if (menu?.classList.contains("menu--active")) {
        burger?.setAttribute("aria-expanded", "true");
        burger?.setAttribute("aria-label", "Закрыть меню");
        disableScroll();
      } else {
        burger?.setAttribute("aria-expanded", "false");
        burger?.setAttribute("aria-label", "Открыть меню");
        enableScroll();
      }
    });

    overlay?.addEventListener("click", () => {
      disableBurger();
    });

    burgerClose?.addEventListener("click", () => {
      disableBurger();
      enableScroll();
    });

    menuItems?.forEach((el) => {
      el.addEventListener("click", () => {
        disableBurger();
      });
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 768) {
        disableBurger();
        enableScroll();
      }
    });

    const disableBurger = () => {
      burger?.setAttribute("aria-expanded", "false");
      burger?.setAttribute("aria-label", "Открыть меню");
      burger.classList.remove("burger--active");
      menu.classList.remove("menu--active");
    };
  },

  modalWindow() {
    const modal = document.getElementById("modal-main");
    const modalBody = modal.querySelector(".modal-body");
    const closeBtn = modal.querySelector(".modal-close");
    const overlay = modal.querySelector(".modal-overlay");
    const widthWindow = 1250;

    function isMobileOrTablet() {
      return window.matchMedia(`(max-width: ${widthWindow}px)`).matches;
    }

    function disableScroll() {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight =
        window.innerWidth - document.documentElement.clientWidth + "px";
    }

    function enableScroll() {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    function openModal(templateId) {
      const template = document.getElementById(templateId);

      if (!template || !template.classList.contains("modal-template")) {
        console.error(
          `Шаблон с ID "${templateId}" не найден или не является модальным`
        );
        return;
      }

      template.classList.add("show");
      modalBody.innerHTML = "";
      modalBody.appendChild(template.cloneNode(true));
      modal.classList.add("show");

      //закрытие меню при ресайзе
      window.addEventListener("resize", () => {
        if (!modal.classList.contains("show")) return;

        const targetElementInModal = modalBody.querySelector("#header-menu");

        if (window.innerWidth > widthWindow && targetElementInModal) {
          closeModal();
        }
      });
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-modal]");
      const menuBtn = e.target.closest("#dropdownMenuBtn");

      if (!btn || (!isMobileOrTablet() && menuBtn)) return;

      const templateId = btn.getAttribute("data-modal");

      e.preventDefault();
      openModal(templateId);

      disableScroll();
    });

    function closeModal() {
      modal.classList.remove("show");
      modalBody.innerHTML = "";

      enableScroll();
    }

    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", closeModal);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });
  },

  PortfolioTabsFilter() {
    const tabsContainer = $("[data-tabs-filter-portfolio]");
    const tabs = tabsContainer.find("[data-tab]");

    tabs.on("click", function () {
      const tab = $(this).attr("data-tab");
      tabs.removeClass("active");
      $(this).addClass("active");

      tabsContainer.find("[data-tab-content]").hide().removeClass("active");

      tabsContainer.find("[data-tab-content]").each(function (i) {
        var tabs = $(this).data("tab-content").split(",");
        if (tabs.indexOf(tab) != -1) {
          $(this).show().addClass("active");
        }
      });
      const activeContent = tabsContainer.find(".bc-item.active");

      tabsContainer.find("[data-tab-content]").removeClass("bc-item--big");

      activeContent.each(function (index) {
        if ((index + 1) % 5 === 4) {
          $(this).addClass("bc-item--big");
        }
      });
    });
  },

  accordion() {
    const accordionItems = document.querySelectorAll("[data-accordion-item]");

    $(accordionItems).each((i, el) => {
      const accordionItemHeader = $(el).find(".accordion__header");
      accordionItemHeader.on("click", () => {
        $(el).toggleClass("accordion__item--active");
        $(el).find(".accordion__content").slideToggle();
      });
    });
  },

  tabsModule() {
    const tabsModule = $("[data-tabs-module]");
    const tabs = tabsModule.find("[data-tab]");
    const tabsContent = tabsModule.find("[data-tab-content]");

    tabs.each((i, el) => {
      $(el).on("click", () => {
        tabs.removeClass("state-active");
        $(el).addClass("state-active");
        tabsContent.removeClass("state-active");
        tabsContent.filter(`[data-tab-content=${i}]`).addClass("state-active");
      });

      if (tabs.length > 0) {
        tabs.eq(0).trigger("click");
      }
    });
  },

  sliderSolutions() {
    Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel]);

    const swiper = new Swiper(".slider-solutions", {
      speed: 700,
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 25,
      autoplay: false,
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },

      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
    });
  },

  sliderCertificates() {
    Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel]);

    const swiper = new Swiper(".slider-certificates", {
      speed: 700,
      effect: "slide",
      slidesPerView: "auto",
      spaceBetween: 25,
      autoplay: false,
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
  },

  sliderCommand() {
    Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel]);

    const swiper = new Swiper(".slider-command", {
      speed: 700,
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 25,
      autoplay: false,
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        440: {
          slidesPerView: "auto",
        },
      },
    });
  },

  geographyTabs() {
    $(".g-tabs-item").each((i, el) => {
      $(el).on("click", () => {
        $(".g-tabs-item").removeClass("g-tabs-item--active");
        $(el).addClass("g-tabs-item--active");
        $(".g-map-item").removeClass("g-map-item--active");
        $(`[data-card=${i + 1}]`).addClass("g-map-item--active");
      });
    });

    $(".g-map-item__close").on("click", () => {
      $(".g-map-item").removeClass("g-map-item--active");
      $(".g-tabs-item").removeClass("g-tabs-item--active");
    });

    $(document).on("click", (e) => {
      if (!$(e.target).closest(".g-tabs-item, .g-map-item").length) {
        $(".g-tabs-item").removeClass("g-tabs-item--active");
        $(".g-map-item").removeClass("g-map-item--active");
      }
    });
  },

  playVideo() {
    const buttonPlay = $(".video-player").find(".vp-button-play");
    const videoUrl = $(".video-player").data("youtube");

    $(buttonPlay).on("click", () => {
      $(".video-player").addClass("state-play");
      const iframe = $(".video-player iframe")[0];
      iframe.src += "&autoplay=1";
    });
  },

  scrollTo(link) {
    link.on("click", function (e) {
      var anchor = $(this);
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(anchor.attr("href")).offset().top,
          },
          {
            duration: 500,
            easing: "swing",
            delay: 0,
          }
        );
      e.preventDefault();
      return false;
    });
  },

  yandexMap() {
    initMap();

    async function initMap() {
      await ymaps3.ready;

      const {
        YMap,
        YMapDefaultSchemeLayer,
        YMapDefaultFeaturesLayer,
        YMapMarker,
      } = ymaps3;

      const CENTER_COORDINATES = [49.10330575050886, 55.830056641307955];
      const MARKER_COORDINATES = [49.10330575050886, 55.830056641307955];
      const LOCATION = { center: CENTER_COORDINATES, zoom: 15 };

      const map = new YMap(document.getElementById("ymap"), {
        location: { center: CENTER_COORDINATES, zoom: 10 },
      });

      map.addChild(new YMapDefaultSchemeLayer());
      map.addChild(new YMapDefaultFeaturesLayer({ zIndex: 1800 }));

      // Создание маркера
      const markerEl = document.createElement("div");
      markerEl.className = "custom-marker";

      const markerImg = document.createElement("img");
      markerImg.src = "/local/templates/cpartner/img/svg/placemark.svg";
      markerImg.alt = "Маркер";
      markerImg.style.width = "40px";
      markerImg.style.height = "40px";

      markerEl.appendChild(markerImg);

      const marker = new YMapMarker(
        { coordinates: MARKER_COORDINATES },
        markerEl
      );
      map.addChild(marker);

      markerEl.onclick = () => {
        map.update({ location: { ...LOCATION, duration: 400 } });
      };
    }
  },

  headerChangeBackground() {
    const offsetTop = 800;

    function toggleBackground() {
      const headerLayout = $("[data-header]");

      if ($(window).scrollTop() > offsetTop) {
        headerLayout.addClass("scrolled");
      } else {
        headerLayout.removeClass("scrolled");
      }
    }

    toggleBackground();

    $(window).on("scroll", () => {
      toggleBackground();
    });
  },
};

App.init();
